I<template>
  <div class="hello">
    <el-row>
      <el-col :span="4">
        <div class="grid-content bg-purple-dark" style="padding-left: 20px">
          璀璨尊品APP后台上传项目
        </div>
      </el-col>
      <el-col :span="20">
        <div class="grid-content bg-purple-dark set">
          <div class="cuican"></div>
          <div class="userset">
            <div>欢迎您, {{ msg }} | </div>
            <!-- <div style="margin: 0 10px" class="handlehover" @click="editpwd()">修改密码 | </div> -->
            <div style="margin: 0 10px" @click="signOut" class="handlehover">退出</div>
          </div>
        </div>
      </el-col>
    </el-row>
    <div>
      <el-dialog
        :title="title"
        :visible.sync="centerDialogVisible"
        width="30%"
        center>
        <el-form :model="form">
          <el-form-item label="原登录密码" :label-width="formLabelWidth">
            <el-input v-model="form.pwd"></el-input>
          </el-form-item>
           <el-form-item label="新登录密码" :label-width="formLabelWidth">
            <el-input v-model="form.newpwd"></el-input>
          </el-form-item>
          <el-form-item label="重复新登录密码" :label-width="formLabelWidth">
            <el-input v-model="form.newpwd2"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button  @click="centerDialogVisible = false">取消</el-button>
          <el-button type="primary" @click="handlesuccess()">确 定</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { loginupdatepwd } from '../api'
import qs from 'qs'
export default {
  name: 'HelloWorld',
  data () {
    return {
      msg: '',
      formLabelWidth: '120px',
      centerDialogVisible: false,
      form: { //  新增初始化form
      },
      title: '修改密码'
    }
  },
  mounted () {
    let user = sessionStorage.getItem('user')
    this.msg = user
  },
  methods: {
    signOut () {
      this.$router.push({ path: '/login' })
    },
    editpwd () {
      this.form = {}
      this.centerDialogVisible = true
    },
    handlesuccess () {
      let para = new URLSearchParams(this.form)
      loginupdatepwd(para).then(data => {
        if (data.code === 10000) {
          this.$message({
            message: data.msg,
            type: 'success'
          })
          this.centerDialogVisible = false
        } else {
          this.$message({
            message: data.msg,
            type: 'error'
          })
        }
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style style lang="stylus" scoped>
.hello
  line-height 4em
.grid-content {
    min-height: 50px;
  }
.bg-purple-dark {
  /* background-color: rgb(84, 92, 100); */
  // background-color: #06466a
  background-color: #1f1f1f
  color #fff
}
.set{
  display: flex;
  justify-content: space-between;
  padding-right: 40px;
}
.userset
  display flex
  justify-content flex-end
.handlehover:hover
  cursor pointer
  text-decoration underline
</style>
